// Sterowanie radiem BEZPOSREDNIO z przegladarki (Web Serial API) -- bez agenta.
// Dziala w Chrome / Edge / Operze na komputerze, tylko przez HTTPS (albo localhost).
// Radio podlaczone kablem USB (wbudowany port CAT -- IC-7300, FT-991, TS-590...)
// albo przez interfejs USB-szeregowy.
//
// Protokoly (sterowniki ponizej -- czyste funkcje kodujace/dekodujace, testowane
// w webSerialCat.test.js):
//   icom          -- CI-V (ramki FE FE .. FD, czestotliwosc w BCD od najmlodszej cyfry)
//   yaesu         -- nowy CAT tekstowy (FA014074000; MD02;) -- FT-991, FT-891, FT-710, FTDX...
//   yaesu-legacy  -- stary binarny CAT 5-bajtowy -- FT-817/818/857/897
//   kenwood       -- tekstowy (FA00014074000; MD2;) -- Kenwood, Elecraft, QRP Labs, (tr)uSDX, Flex (SmartSDR CAT)
//
// Tryby jak w agencie: USB/LSB -> SSB, DATA -> FT8; SSB wysylamy jako LSB ponizej
// 10 MHz, powyzej USB; FT8/FT4/PSK/JS8 -> USB z trybem danych.
//
// Kazdy sterownik: poll() / pollSlow() (odczyt), feed(bytes) -> {hz, mode, sdb, watts},
// setFreq, setMode, split(txHz) / splitOff(), ptt(on), opcjonalnie cw(text) / cwStop(),
// repeater({offsetHz, ctcss}) / simplex(). Metody, ktorych radio nie umie, nie istnieja.
//
// NADAWANIE (PTT, tekst CW) jest zablokowane, dopoki uzytkownik nie wlaczy zgody
// w panelu radia (isTxAllowed) -- tak jak allow_tx_control w agencie.
import { useSyncExternalStore } from 'react';
import { tx } from './i18n';

export const RIG_PRESETS = [
  { id: 'ic7300', label: 'Icom IC-7300', protocol: 'icom', civ: 0x94, baud: 115200, dataMode: true, maxW: 100 },
  { id: 'ic705', label: 'Icom IC-705', protocol: 'icom', civ: 0xA4, baud: 115200, dataMode: true, maxW: 10 },
  { id: 'ic9700', label: 'Icom IC-9700', protocol: 'icom', civ: 0xA2, baud: 115200, dataMode: true, maxW: 100 },
  { id: 'ic7610', label: 'Icom IC-7610', protocol: 'icom', civ: 0x98, baud: 115200, dataMode: true, maxW: 100 },
  { id: 'ic7100', label: 'Icom IC-7100', protocol: 'icom', civ: 0x88, baud: 19200, dataMode: true, maxW: 100 },
  { id: 'ic7851', label: 'Icom IC-7850 / IC-7851', protocol: 'icom', civ: 0x8E, baud: 115200, dataMode: true, maxW: 200 },
  { id: 'ic7760', label: 'Icom IC-7760', protocol: 'icom', civ: 0xB2, baud: 115200, dataMode: true, maxW: 200 },
  { id: 'ic905', label: 'Icom IC-905', protocol: 'icom', civ: 0xAC, baud: 115200, dataMode: true, maxW: 10 },
  { id: 'ic7600', label: 'Icom IC-7600', protocol: 'icom', civ: 0x7A, baud: 19200, dataMode: true, maxW: 100 },
  { id: 'ic7410', label: 'Icom IC-7410', protocol: 'icom', civ: 0x80, baud: 19200, dataMode: true, maxW: 100 },
  { id: 'ic9100', label: 'Icom IC-9100', protocol: 'icom', civ: 0x7C, baud: 19200, dataMode: true, maxW: 100 },
  { id: 'ic7200', label: 'Icom IC-7200', protocol: 'icom', civ: 0x76, baud: 19200, dataMode: false, maxW: 100 },
  { id: 'ic7000', label: 'Icom IC-7000', protocol: 'icom', civ: 0x70, baud: 19200, dataMode: false, maxW: 100 },
  { id: 'ic718', label: 'Icom IC-718', protocol: 'icom', civ: 0x5E, baud: 19200, dataMode: false, maxW: 100 },
  { id: 'ic706', label: 'Icom IC-706MkIIG', protocol: 'icom', civ: 0x58, baud: 19200, dataMode: false, maxW: 100 },
  { id: 'xiegu-g90', label: 'Xiegu G90 / X5105 / G106', protocol: 'icom', civ: 0x70, baud: 19200, dataMode: false, maxW: 20 },
  { id: 'xiegu-x6100', label: 'Xiegu X6100 / X6200', protocol: 'icom', civ: 0xA4, baud: 19200, dataMode: false, maxW: 10 },
  { id: 'icom', label: 'Icom (CI-V, inny model)', protocol: 'icom', civ: 0x94, baud: 19200, dataMode: false, maxW: 100 },
  { id: 'ft991', label: 'Yaesu FT-991 / FT-991A', protocol: 'yaesu', baud: 38400 },
  { id: 'ft710', label: 'Yaesu FT-710 / FTDX10 / FTDX101', protocol: 'yaesu', baud: 38400 },
  { id: 'ft891', label: 'Yaesu FT-891', protocol: 'yaesu', baud: 38400 },
  { id: 'ft450', label: 'Yaesu FT-450 / FT-950 / FT-2000', protocol: 'yaesu', baud: 38400 },
  { id: 'ftdx3000', label: 'Yaesu FTDX1200 / FTDX3000 / FTDX5000', protocol: 'yaesu', baud: 38400 },
  { id: 'ft817', label: 'Yaesu FT-817 / 818 / 857 / 897', protocol: 'yaesu-legacy', baud: 4800 },
  { id: 'kenwood', label: 'Kenwood TS-590 / TS-890 / TS-480', protocol: 'kenwood', baud: 115200 },
  { id: 'ts2000', label: 'Kenwood TS-2000 / TS-990', protocol: 'kenwood', baud: 57600 },
  { id: 'elecraft', label: 'Elecraft K3 / K4 / KX2 / KX3', protocol: 'kenwood', baud: 38400, elecraft: true },
  { id: 'qrplabs', label: 'QRP Labs QMX / QDX, (tr)uSDX', protocol: 'kenwood', baud: 115200 },
  { id: 'flex', label: 'FlexRadio (port SmartSDR CAT)', protocol: 'kenwood', baud: 115200 },
  { id: 'tx500', label: 'Lab599 TX-500', protocol: 'kenwood', baud: 9600 },
];
export const BAUD_RATES = [4800, 9600, 19200, 38400, 57600, 115200];
const DATA_MODES = new Set(['FT8', 'FT4', 'PSK31', 'JS8', 'JT65', 'JT9', 'WSPR', 'MSK144', 'OLIVIA', 'SSTV']);
const enc = (s) => new TextEncoder().encode(s);
const isSideband = (mode) => mode === 'SSB' || mode === 'USB' || mode === 'LSB';
const lowerSideband = (hz) => hz < 10e6;
// Standardowe tony CTCSS (kolejnosc = numer tonu w radiach Yaesu, komenda CN)
export const CTCSS_TONES = [67.0, 69.3, 71.9, 74.4, 77.0, 79.7, 82.5, 85.4, 88.5, 91.5, 94.8, 97.4, 100.0, 103.5, 107.2,
  110.9, 114.8, 118.8, 123.0, 127.3, 131.8, 136.5, 141.3, 146.2, 151.4, 156.7, 159.8, 162.2, 165.5, 167.9, 171.3, 173.8,
  177.3, 179.9, 183.5, 186.2, 189.9, 192.8, 196.6, 199.5, 203.5, 206.5, 210.7, 218.1, 225.7, 229.1, 233.6, 241.8, 250.3, 254.1];
const CW_OK = /[^A-Z0-9/?.,=+ ]/g;
const cwClean = (text) => String(text || '').toUpperCase().replace(CW_OK, '').replace(/\s+/g, ' ').trim().slice(0, 60);
const chunks = (s, n) => s.match(new RegExp(`.{1,${n}}`, 'g')) || [];

// ── S-metr: surowy odczyt radia -> dB wzgledem S9 (S9 = 0, S7 = -12, S9+20 = +20) ──
// Tabele [surowe, dB] -- interpolacja liniowa miedzy punktami. Zrodla: instrukcje
// CAT producentow i kalibracje Hamlib; 6 dB na jednostke S ponizej S9.
const CAL_ICOM = [[0, -54], [120, 0], [241, 60]];                         // 0000-0255, S9=0120, S9+60=0241
const CAL_YAESU = [[0, -54], [12, -48], [27, -42], [40, -36], [55, -30], [65, -24], [80, -18], [95, -12],
  [112, -6], [130, 0], [150, 10], [172, 20], [190, 30], [220, 40], [240, 50], [255, 60]];   // FT-991/710/891: 000-255
const CAL_KENWOOD = [[0, -54], [15, 0], [30, 60]];                        // TS-480/590/2000: 0000-0030, S9=15
const CAL_KENWOOD_70 = [[0, -54], [35, 0], [70, 60]];                     // TS-890 i inne ze skala 0-70
const CAL_ELECRAFT = [[0, -54], [6, 0], [15, 60]];                        // K3/KX3/KX2: 0000-0015, S9=6, +20 co 3
const CAL_ELECRAFT_K31 = [[0, -54], [9, 0], [21, 60]];                    // K3 w trybie K31: 0000-0021, S9=9
export function calibrate(raw, table) {
  if (raw <= table[0][0]) return table[0][1];
  for (let i = 1; i < table.length; i++) {
    const [r1, d1] = table[i];
    if (raw <= r1) {
      const [r0, d0] = table[i - 1];
      return Math.round(d0 + (d1 - d0) * (raw - r0) / (r1 - r0));
    }
  }
  return table[table.length - 1][1];
}
// dB wzgledem S9 -> tekst S-metra ("S7", "S9+20") i cyfra S do RST (1-9)
export function sUnitsLabel(db) {
  if (db == null) return '';
  if (db > 0) return `S9+${Math.round(db / 10) * 10 || db}`;
  return `S${Math.max(0, Math.min(9, Math.round(9 + db / 6)))}`;
}
export function rstFromSmeter(db, mode) {
  const s = Math.max(1, Math.min(9, Math.round(9 + Math.min(0, db) / 6)));
  return ['CW', 'RTTY', 'PSK31'].includes(mode) ? `5${s}9` : `5${s}`;
}

// ── Split z komentarza spotu: "UP 5", "UP", "QSX 14.205", "DOWN 2", "U1" ──────
// Zwraca czestotliwosc NADAWANIA w MHz albo null. "UP" bez liczby: 1 kHz na CW/cyfrowych, 5 kHz na fonii.
export function parseSplit(comment, freqMHz, mode) {
  const c = ` ${String(comment || '').toUpperCase()} `;
  const f = Number(freqMHz);
  if (!f) return null;
  let m;
  if ((m = /\bQSX\s*(\d{1,3}\.\d{2,4}|\d{4,6}(?:\.\d+)?)\b/.exec(c))) {
    const v = parseFloat(m[1]);
    const mhz = v > 1000 ? v / 1000 : v;
    return Math.abs(mhz - f) < 0.1 ? +mhz.toFixed(6) : null;
  }
  const phone = ['SSB', 'USB', 'LSB', 'AM', 'FM'].includes(String(mode || '').toUpperCase()) || (!mode && isPhoneSegment(f));
  // "UP", "UP 5", "UP5", "DOWN 2", "DN2" albo skrot z liczba: "U1", "D2" (samo "U"/"D" to nie split)
  m = /\s(UP|DOWN|DN)\s*(\d{1,2}(?:\.\d)?)?(?:\s*-\s*\d{1,2}(?:\.\d)?)?\s*(?:K|KHZ)?\s/.exec(c)
    || /\s(U|D)(\d{1,2}(?:\.\d)?)\s/.exec(c);
  if (!m) return null;
  const khz = m[2] ? parseFloat(m[2]) : (phone ? 5 : 1);
  if (!(khz > 0 && khz <= 30)) return null;
  return +(f + (m[1].startsWith('U') ? 1 : -1) * khz / 1000).toFixed(6);
}
function isPhoneSegment(f) {
  const frac = f - Math.floor(f);
  return f >= 28.3 || (f < 10 ? frac > 0.06 : frac > 0.1);
}

// ── Kenwood / Elecraft / QRP Labs (tekst, ';') ────────────────────────────────
const KENWOOD_READ = { 1: 'SSB', 2: 'SSB', 3: 'CW', 4: 'FM', 5: 'AM', 6: 'RTTY', 7: 'CW', 9: 'RTTY' };
export function kenwoodDriver(opts = {}) {
  let buf = '';
  let wide = false;             // wykryta szersza skala S-metra (TS-890 / Elecraft K31)
  const fa = (p, hz) => enc(`${p}${String(Math.round(hz)).padStart(11, '0')};`);
  return {
    poll: () => [enc('FA;'), enc('MD;'), enc(opts.elecraft ? 'SM;' : 'SM0;')],
    pollSlow: () => [enc('PC;')],
    feed(bytes) {
      buf += new TextDecoder().decode(bytes);
      const out = {};
      let i;
      while ((i = buf.indexOf(';')) >= 0) {
        const tok = buf.slice(0, i).trim();
        buf = buf.slice(i + 1);
        let m;
        if ((m = /^FA(\d{8,11})$/.exec(tok))) out.hz = parseInt(m[1], 10);
        else if ((m = /^MD(\d)$/.exec(tok))) {
          const code = +m[1];
          out.mode = opts.elecraft && code === 6 ? 'FT8' : (KENWOOD_READ[code] || out.mode);
        } else if ((m = /^SM(\d{4,5})$/.exec(tok))) {
          // Kenwood: SM0nnnn (0-30, TS-890: 0-70); Elecraft: SMnnnn (0-15, K3 w trybie K31: 0-21)
          const raw = parseInt(m[1].slice(-4), 10);
          if (opts.elecraft) wide = wide || raw > 15;
          else wide = wide || raw > 30;
          out.sdb = calibrate(raw, opts.elecraft ? (wide ? CAL_ELECRAFT_K31 : CAL_ELECRAFT) : (wide ? CAL_KENWOOD_70 : CAL_KENWOOD));
        } else if ((m = /^PC(\d{3})$/.exec(tok))) out.watts = parseInt(m[1], 10);
      }
      if (buf.length > 200) buf = '';
      return out;
    },
    setFreq: (hz) => [fa('FA', hz)],
    setMode(mode, hz) {
      let code = { CW: 3, FM: 4, AM: 5, RTTY: 6 }[mode];
      if (isSideband(mode)) code = lowerSideband(hz) ? 1 : 2;
      if (DATA_MODES.has(mode)) code = opts.elecraft ? 6 : 2;
      return code ? [enc(`MD${code};`)] : [];
    },
    // Odbior VFO A, nadawanie VFO B (FR0 przed FT1 -- w Elecrafcie FR0 kasuje split)
    split: (txHz) => [fa('FB', txHz), enc('FR0;'), enc('FT1;')],
    splitOff: () => [enc('FT0;')],
    ptt: (on) => [enc(on ? 'TX;' : 'RX;')],
    // Kenwood: KY + spacja + dokladnie 24 znaki; Elecraft: KY + spacja + do 24 znakow
    cw: (text) => chunks(cwClean(text), 24).map(c => enc(`KY ${opts.elecraft ? c : c.padEnd(24)};`)),
    cwStop: () => [enc('RX;')],
  };
}

// ── Yaesu nowy CAT (tekst, ';', tryb w hex) ───────────────────────────────────
const YAESU_READ = { 1: 'SSB', 2: 'SSB', 3: 'CW', 7: 'CW', 4: 'FM', B: 'FM', 5: 'AM', D: 'AM', 6: 'RTTY', 9: 'RTTY', 8: 'FT8', C: 'FT8', A: 'FT8' };
export function yaesuDriver() {
  let buf = '';
  let digits = 9;               // FT-991/FT-710: 9 cyfr; starsze (FT-950, FTDX5000): 8 -- uczymy sie z odpowiedzi
  const fa = (p, hz) => enc(`${p}${String(Math.round(hz)).padStart(digits, '0')};`);
  return {
    poll: () => [enc('FA;'), enc('MD0;'), enc('SM0;')],
    pollSlow: () => [enc('PC;')],
    feed(bytes) {
      buf += new TextDecoder().decode(bytes);
      const out = {};
      let i;
      while ((i = buf.indexOf(';')) >= 0) {
        const tok = buf.slice(0, i).trim();
        buf = buf.slice(i + 1);
        let m;
        if ((m = /^FA(\d{8,9})$/.exec(tok))) { digits = m[1].length; out.hz = parseInt(m[1], 10); }
        else if ((m = /^MD0([0-9A-F])$/i.exec(tok))) out.mode = YAESU_READ[m[1].toUpperCase()] || out.mode;
        else if ((m = /^SM0(\d{3})$/.exec(tok))) out.sdb = calibrate(parseInt(m[1], 10), CAL_YAESU);
        else if ((m = /^PC(\d{3})$/.exec(tok))) out.watts = parseInt(m[1], 10);
      }
      if (buf.length > 200) buf = '';
      return out;
    },
    setFreq: (hz) => [fa('FA', hz)],
    setMode(mode, hz) {
      let code = { CW: '3', FM: '4', AM: '5', RTTY: '6' }[mode];
      if (isSideband(mode)) code = lowerSideband(hz) ? '1' : '2';
      if (DATA_MODES.has(mode)) code = 'C';          // DATA-U
      return code ? [enc(`MD0${code};`)] : [];
    },
    // ST1 = split w FT-991/710/891/FTDX10/101; FT1 = nadawanie z VFO-B w starszych
    // (FT-450/950/2000) -- nieznana komenda konczy sie "?;" i jest ignorowana
    split: (txHz) => [fa('FB', txHz), enc('ST1;'), enc('FT1;')],
    splitOff: () => [enc('ST0;'), enc('FT0;')],
    ptt: (on) => [enc(on ? 'TX1;' : 'TX0;')],
    // Tekst trafia do pamieci klucza nr 5 (KM5) i jest z niej nadawany (KYA) --
    // pamiec 5 w radiu zostaje nadpisana; w menu radia pamiec musi byc typu TEXT
    cw: (text) => { const t = cwClean(text).slice(0, 49); return t ? [enc(`KM5${t}};`), enc('KYA;')] : []; },
    // Przemiennik: kierunek przesuniecia + koder CTCSS; wielkosc przesuniecia bierze radio (ARS / menu)
    repeater({ offsetHz, ctcss }) {
      const out = [enc(offsetHz > 0 ? 'OS01;' : offsetHz < 0 ? 'OS02;' : 'OS00;')];
      const idx = ctcss ? CTCSS_TONES.findIndex(tn => Math.abs(tn - ctcss) < 0.05) : -1;
      if (idx >= 0) out.push(enc(`CN00${String(idx).padStart(3, '0')};`), enc('CT02;'));
      else out.push(enc('CT00;'));
      return out;
    },
    simplex: () => [enc('OS00;'), enc('CT00;')],
  };
}

// ── Icom CI-V (binarnie, FE FE to from cmd ... FD) ────────────────────────────
const CTRL = 0xE0;              // adres "komputera"
export function bcdLE(hz, bytes = 5) {
  const out = [];
  let n = Math.round(hz);
  for (let i = 0; i < bytes; i++) { const two = n % 100; n = Math.floor(n / 100); out.push(((Math.floor(two / 10)) << 4) | (two % 10)); }
  return out;
}
export function fromBcdLE(arr) {
  let hz = 0, mul = 1;
  for (const b of arr) { hz += ((b >> 4) * 10 + (b & 0x0F)) * mul; mul *= 100; }
  return hz;
}
const bcdByte = (b) => (b >> 4) * 10 + (b & 0x0F);
const toBcdByte = (n) => ((Math.floor(n / 10) % 10) << 4) | (n % 10);
const ICOM_READ = { 0x00: 'SSB', 0x01: 'SSB', 0x02: 'AM', 0x03: 'CW', 0x07: 'CW', 0x04: 'RTTY', 0x08: 'RTTY', 0x05: 'FM', 0x06: 'FM', 0x17: 'DSTAR' };
export function icomDriver(opts = {}) {
  const civ = opts.civ ?? 0x94;
  const maxW = opts.maxW || 100;
  const frame = (...body) => new Uint8Array([0xFE, 0xFE, civ, CTRL, ...body, 0xFD]);
  let buf = [];
  let data = false, sideband = false;
  return {
    poll: () => [frame(0x03), frame(0x04), ...(opts.dataMode ? [frame(0x1A, 0x06)] : []), frame(0x15, 0x02)],
    pollSlow: () => [frame(0x14, 0x0A)],
    feed(bytes) {
      buf.push(...bytes);
      const out = {};
      for (;;) {
        const s = buf.findIndex((b, i) => b === 0xFE && buf[i + 1] === 0xFE);
        if (s < 0) { buf = []; break; }
        const e = buf.indexOf(0xFD, s + 2);
        if (e < 0) { buf = buf.slice(s); break; }
        const f = buf.slice(s + 2, e);      // to, from, cmd, dane
        buf = buf.slice(e + 1);
        if (f.length < 3 || f[1] === CTRL) continue;           // echo naszej komendy
        if (f[0] !== CTRL && f[0] !== 0x00) continue;          // nie do nas (i nie rozgloszenie)
        const cmd = f[2], d = f.slice(3);
        if ((cmd === 0x03 || cmd === 0x00) && d.length >= 5) out.hz = fromBcdLE(d.slice(0, 5));
        else if ((cmd === 0x04 || cmd === 0x01) && d.length >= 1) {
          sideband = d[0] === 0x00 || d[0] === 0x01;
          out.mode = ICOM_READ[d[0]] || out.mode;
          if (sideband && data) out.mode = 'FT8';
        } else if (cmd === 0x15 && d[0] === 0x02 && d.length >= 3) {
          out.sdb = calibrate(bcdByte(d[1]) * 100 + bcdByte(d[2]), CAL_ICOM);    // 0000-0255, BCD od najstarszej cyfry
        } else if (cmd === 0x14 && d[0] === 0x0A && d.length >= 3) {
          // Ustawiona moc: 0000-0255 = 0-100% mocy maksymalnej modelu
          out.watts = Math.max(1, Math.round((bcdByte(d[1]) * 100 + bcdByte(d[2])) / 255 * maxW));
        } else if (cmd === 0x1A && d[0] === 0x06 && d.length >= 2) {
          data = d[1] > 0;
          if (sideband) out.mode = data ? 'FT8' : 'SSB';
        }
      }
      if (buf.length > 512) buf = [];
      return out;
    },
    setFreq: (hz) => [frame(0x05, ...bcdLE(hz))],
    setMode(mode, hz) {
      if (DATA_MODES.has(mode)) {
        return [frame(0x06, 0x01, 0x01), ...(opts.dataMode ? [frame(0x1A, 0x06, 0x01, 0x01)] : [])];
      }
      let code = { CW: 0x03, FM: 0x05, AM: 0x02, RTTY: 0x04 }[mode];
      if (isSideband(mode)) code = lowerSideband(hz) ? 0x00 : 0x01;
      if (code === undefined) return [];
      return [frame(0x06, code, 0x01), ...(opts.dataMode && (code <= 0x01) ? [frame(0x1A, 0x06, 0x00, 0x00)] : [])];
    },
    // VFO B dostaje czestotliwosc nadawania, wracamy na VFO A, split wlaczony
    split: (txHz) => [frame(0x07, 0x01), frame(0x05, ...bcdLE(txHz)), frame(0x07, 0x00), frame(0x0F, 0x01)],
    splitOff: () => [frame(0x0F, 0x00)],
    ptt: (on) => [frame(0x1C, 0x00, on ? 0x01 : 0x00)],
    cw: (text) => chunks(cwClean(text), 30).map(c => frame(0x17, ...enc(c))),
    cwStop: () => [frame(0x17, 0xFF)],
    // Przemiennik: kierunek (DUP-/DUP+), przesuniecie w jednostkach 100 Hz (3 bajty BCD), ton + koder
    repeater({ offsetHz, ctcss }) {
      if (!offsetHz) return this.simplex();
      const out = [frame(0x0D, ...bcdLE(Math.abs(offsetHz) / 100, 3)), frame(0x0F, offsetHz < 0 ? 0x11 : 0x12)];
      if (ctcss) {
        const t10 = Math.round(ctcss * 10);
        out.push(frame(0x1B, 0x00, 0x00, toBcdByte(Math.floor(t10 / 100)), toBcdByte(t10 % 100)), frame(0x16, 0x42, 0x01));
      } else out.push(frame(0x16, 0x42, 0x00));
      return out;
    },
    simplex: () => [frame(0x0F, 0x10), frame(0x16, 0x42, 0x00)],
  };
}

// ── Yaesu stary CAT (FT-817/818/857/897): 5 bajtow, odpowiedz 5 bajtow ─────────
const LEGACY_READ = { 0x00: 'SSB', 0x01: 'SSB', 0x02: 'CW', 0x03: 'CW', 0x04: 'AM', 0x06: 'FM', 0x08: 'FM', 0x88: 'FM', 0x0A: 'FT8', 0x0C: 'FT8' };
const bcdBE4 = (n) => {
  const d = [];
  for (let i = 0; i < 4; i++) { const two = n % 100; n = Math.floor(n / 100); d.unshift(toBcdByte(two)); }
  return d;
};
export function yaesuLegacyDriver() {
  let buf = [];
  let expect = [];                           // kolejka dlugosci oczekiwanych odpowiedzi
  const op = (...b) => new Uint8Array(b);
  return {
    poll() {
      buf = []; expect = [5, 1];
      return [op(0, 0, 0, 0, 0x03), op(0, 0, 0, 0, 0xE7)];
    },
    feed(bytes) {
      buf.push(...bytes);
      const out = {};
      while (expect.length && buf.length >= expect[0]) {
        const n = expect.shift();
        const b = buf.splice(0, n);
        if (n === 5) {
          // 4 bajty BCD, od najstarszej cyfry, w jednostkach 10 Hz. Spoznione potwierdzenie
          // wczesniejszej komendy przesuwa ramke -- wtedy cyfry / tryb sa nieprawidlowe i odczyt odrzucamy.
          const valid = b.slice(0, 4).every(x => (x >> 4) <= 9 && (x & 0x0F) <= 9) && LEGACY_READ[b[4]] !== undefined;
          let tens = 0;
          for (let i = 0; i < 4; i++) tens = tens * 100 + bcdByte(b[i]);
          if (valid && tens >= 150000 && tens <= 47000000) { out.hz = tens * 10; out.mode = LEGACY_READ[b[4]]; }
          else { expect = []; }
        } else {
          // Status RX: bity 0-3 = S-metr 0-15 (0-9 = S0-S9, 10-15 = S9+10..+60)
          const s = b[0] & 0x0F;
          out.sdb = s <= 9 ? (s - 9) * 6 : (s - 9) * 10;
        }
      }
      if (!expect.length) buf = [];
      return out;
    },
    setFreq: (hz) => [op(...bcdBE4(Math.round(hz / 10)), 0x01)],
    setMode(mode, hz) {
      let code = { CW: 0x02, FM: 0x08, AM: 0x04 }[mode];
      if (isSideband(mode)) code = lowerSideband(hz) ? 0x00 : 0x01;
      if (DATA_MODES.has(mode)) code = 0x0A;
      return code === undefined ? [] : [op(code, 0, 0, 0, 0x07)];
    },
    // Przelacz VFO, ustaw czestotliwosc nadawania, wroc, wlacz split
    split: (txHz) => [op(0, 0, 0, 0, 0x81), op(...bcdBE4(Math.round(txHz / 10)), 0x01), op(0, 0, 0, 0, 0x81), op(0, 0, 0, 0, 0x02)],
    splitOff: () => [op(0, 0, 0, 0, 0x82)],
    ptt: (on) => [op(0, 0, 0, 0, on ? 0x08 : 0x88)],
    repeater({ offsetHz, ctcss }) {
      if (!offsetHz) return this.simplex();
      const out = [op(offsetHz < 0 ? 0x09 : 0x49, 0, 0, 0, 0x09), op(...bcdBE4(Math.round(Math.abs(offsetHz) / 10)), 0xF9)];
      if (ctcss) {
        const t10 = Math.round(ctcss * 10);
        out.push(op(toBcdByte(Math.floor(t10 / 100)), toBcdByte(t10 % 100), 0, 0, 0x0B), op(0x4A, 0, 0, 0, 0x0A));
      } else out.push(op(0x8A, 0, 0, 0, 0x0A));
      return out;
    },
    simplex: () => [op(0x89, 0, 0, 0, 0x09), op(0x8A, 0, 0, 0, 0x0A)],
  };
}

export function makeDriver(preset, civ) {
  switch (preset.protocol) {
    case 'icom': return icomDriver({ civ: civ ?? preset.civ, dataMode: preset.dataMode, maxW: preset.maxW });
    case 'yaesu': return yaesuDriver();
    case 'yaesu-legacy': return yaesuLegacyDriver();
    default: return kenwoodDriver({ elecraft: preset.elecraft });
  }
}

// ── Polaczenie (jedno na karte przegladarki) ──────────────────────────────────
const STORE = 'webserial_rig';
const TX_STORE = 'webserial_allow_tx';
const POLL_MS = 700;
const SLOW_EVERY = 6;            // moc: co 6. odpytanie (~4 s)
const PTT_MAX_MS = 180000;       // bezpiecznik: PTT z loggera samo puszcza po 3 min
export const isWebSerialSupported = () => typeof navigator !== 'undefined' && 'serial' in navigator;
const readTxAllowed = () => { try { return localStorage.getItem(TX_STORE) === '1'; } catch { return false; } };

let state = { status: 'disconnected', frequency: null, mode: null, smeterPeak: null, power: null, splitTx: null,
  repeater: false, ptt: false, allowTx: readTxAllowed(), caps: {}, error: null, presetId: null, detecting: null };
let lastSeen = 0;
// Probki S-metra z ostatnich kilku sekund -- raport daje sie ze szczytu, nie z chwilowego dolka fadingu
const SMETER_WINDOW_MS = 5000;
let smeterSamples = [];
// Po komendach przelaczajacych VFO (split) radio przez chwile zglasza czestotliwosc VFO B -- pomijamy te odczyty
let muteFreqUntil = 0;
let splitRx = null;              // czestotliwosc odbioru (MHz), przy ktorej ustawilismy split
const listeners = new Set();
const emit = (patch) => { state = { ...state, ...patch }; listeners.forEach(l => l()); };
let port = null, reader = null, driver = null, pollTimer = null, pttTimer = null, tickNo = 0, writeChain = Promise.resolve();

export function savedRigConfig() {
  try { return JSON.parse(localStorage.getItem(STORE)) || null; } catch { return null; }
}
export const isTxAllowed = () => state.allowTx;
export function setTxAllowed(on) {
  try { localStorage.setItem(TX_STORE, on ? '1' : '0'); } catch { /* brak storage */ }
  if (!on && state.ptt) rigPtt(false).catch(() => {});
  emit({ allowTx: !!on });
}

// Zapamietany port: przegladarka oddaje tylko porty, na ktore uzytkownik juz sie zgodzil;
// rozrozniamy je po identyfikatorach USB (radio i obrotnica to zwykle rozne przejsciowki)
export const portInfo = (p) => { try { const i = p.getInfo(); return { vid: i.usbVendorId ?? null, pid: i.usbProductId ?? null }; } catch { return { vid: null, pid: null }; } };
export async function findRememberedPort(info) {
  const ports = (await navigator.serial.getPorts()).filter(p => !p.readable);     // nie te juz otwarte (np. obrotnica)
  const same = info ? ports.filter(p => { const i = portInfo(p); return i.vid === info.vid && i.pid === info.pid; }) : ports;
  return same.length === 1 ? same[0] : null;
}

async function write(cmds, gap = 40) {
  writeChain = writeChain.then(async () => {
    if (!port?.writable) return;
    const w = port.writable.getWriter();
    try { for (const c of cmds) { await w.write(c); await new Promise(r => setTimeout(r, gap)); } }
    finally { w.releaseLock(); }
  }).catch(() => {});
  return writeChain;
}

async function readLoop() {
  while (port?.readable) {
    reader = port.readable.getReader();
    try {
      for (;;) {
        const { value, done } = await reader.read();
        if (done) break;
        const upd = driver.feed(value);
        const patch = {};
        if (upd.sdb != null && !state.ptt) {
          const now = Date.now();
          smeterSamples = smeterSamples.filter(s => now - s.t < SMETER_WINDOW_MS);
          smeterSamples.push({ t: now, db: upd.sdb });
          patch.smeterPeak = Math.max(...smeterSamples.map(s => s.db));
        }
        if (upd.watts != null) patch.power = upd.watts;
        if (upd.hz || upd.mode) {
          lastSeen = Date.now();
          const freqOk = upd.hz && Date.now() >= muteFreqUntil;
          Object.assign(patch, { status: 'connected', error: null,
            ...(freqOk ? { frequency: upd.hz / 1e6 } : {}), ...(upd.mode ? { mode: upd.mode } : {}) });
          // Odstrojenie o ponad 5 kHz od stacji, dla ktorej ustawiono split = split juz nieaktualny
          // (do logu nie moze trafic stara czestotliwosc nadawania)
          if (freqOk && state.splitTx && splitRx && Math.abs(upd.hz / 1e6 - splitRx) > 0.005) { patch.splitTx = null; splitRx = null; }
        }
        // Tylko gdy cos sie naprawde zmienilo -- inaczej kazde odpytanie (co 0,7 s)
        // przerysowywaloby cala aplikacje (App uzywa tego stanu)
        if (Object.keys(patch).some(k => patch[k] !== state[k])) emit(patch);
      }
    } catch (e) {
      if (port) emit({ error: String(e.message || e) });
      break;
    } finally {
      try { reader.releaseLock(); } catch { /* juz zwolniony */ }
    }
  }
}

export async function connectRig({ presetId, baud, civ, pick = true, portObj = null }) {
  if (!isWebSerialSupported()) throw new Error('Web Serial nie jest dostepny w tej przegladarce');
  const preset = RIG_PRESETS.find(p => p.id === presetId) || RIG_PRESETS[0];
  await disconnectRig(false);
  emit({ status: 'connecting', error: null, presetId: preset.id });
  try {
    if (portObj) port = portObj;
    else if (pick) port = await navigator.serial.requestPort();
    else {
      port = await findRememberedPort(savedRigConfig()?.usb);
      if (!port) throw new Error('no-remembered-port');
    }
    await port.open({ baudRate: baud || preset.baud, dataBits: 8, parity: 'none', flowControl: 'none',
      stopBits: preset.protocol === 'yaesu-legacy' ? 2 : 1 });
    // DTR/RTS wylaczone -- na wielu radiach (np. IC-7300) steruja nadawaniem (PTT/klucz)
    try { await port.setSignals({ dataTerminalReady: false, requestToSend: false }); } catch { /* nie kazdy port */ }
    driver = makeDriver(preset, civ);
    try {
      localStorage.setItem(STORE, JSON.stringify({ presetId: preset.id, baud: baud || preset.baud, civ: civ ?? preset.civ ?? null,
        usb: portInfo(port), auto: true }));
    } catch { /* brak storage */ }
    readLoop();
    tickNo = 0;
    const tick = () => write([...driver.poll(), ...(tickNo++ % SLOW_EVERY === 0 && driver.pollSlow ? driver.pollSlow() : [])]);
    tick();
    pollTimer = setInterval(() => {
      if (!state.ptt) tick();
      if (lastSeen && Date.now() - lastSeen > 5000 && state.status !== 'connecting' && !state.ptt) {
        emit({ status: 'connecting', error: tx('Radio nie odpowiada — sprawdź model, prędkość i ustawienia CAT w radiu') });
      }
    }, POLL_MS);
    emit({ status: 'connecting', caps: { cw: !!driver.cw, cwStop: !!driver.cwStop, repeater: !!driver.repeater, ptt: !!driver.ptt, split: !!driver.split } });
  } catch (e) {
    port = null;
    const msg = e.name === 'NotFoundError' ? null : (e.message === 'no-remembered-port' ? null : String(e.message || e));
    emit({ status: 'disconnected', error: msg });
    if (msg) throw e;
  }
}

export async function disconnectRig(forget = true) {
  clearInterval(pollTimer); pollTimer = null;
  clearTimeout(pttTimer); pttTimer = null;
  if (state.ptt && driver?.ptt && port) { try { await write(driver.ptt(false)); } catch { /* nic */ } }   // nigdy nie zostawiaj nadajnika wlaczonego
  const p = port; port = null;
  try { await reader?.cancel(); } catch { /* juz zamkniety */ }
  try { await writeChain; } catch { /* nic */ }
  try { await p?.close(); } catch { /* juz zamkniety */ }
  reader = null; driver = null;
  if (forget) { try { const c = savedRigConfig(); if (c) localStorage.setItem(STORE, JSON.stringify({ ...c, auto: false })); } catch { /* nic */ } }
  smeterSamples = [];
  lastSeen = 0;
  emit({ status: 'disconnected', frequency: null, mode: null, smeterPeak: null, power: null, splitTx: null, repeater: false, ptt: false, caps: {} });
}

// QSY. opts.splitTx (MHz) -- nadawanie na innej czestotliwosci (DX "UP 5");
// opts.repeater {offsetMHz, ctcss} -- przesuniecie i ton przemiennika (gdy radio nie
// umie ustawic przesuniecia przez CAT, uzywamy splitu: nadawanie na wejsciu przemiennika).
export async function rigQsy(freqMHz, mode, opts = {}) {
  if (!driver || !port) throw new Error(tx('Radio nie jest podłączone'));
  const hz = Math.round(Number(freqMHz) * 1e6);
  const cmds = [];
  if (hz > 0) cmds.push(...driver.setFreq(hz));
  if (mode) cmds.push(...driver.setMode(String(mode).toUpperCase(), hz || (state.frequency || 14) * 1e6));
  if (opts.keepSplit) {                                    // strojenie krok po kroku -- split / przemiennik bez zmian
    await write(cmds);
    return;
  }
  let splitTx = opts.splitTx ? Number(opts.splitTx) : null;
  let repeater = false;
  const rp = opts.repeater && opts.repeater.offsetMHz ? opts.repeater : null;
  if (rp && driver.repeater) {
    cmds.push(...driver.repeater({ offsetHz: Math.round(rp.offsetMHz * 1e6), ctcss: rp.ctcss || null }));
    repeater = true;
  } else {
    if (rp) splitTx = +(Number(freqMHz) + rp.offsetMHz).toFixed(6);
    if (state.repeater && driver.simplex) cmds.push(...driver.simplex());
  }
  if (splitTx && driver.split) {
    cmds.push(...driver.split(Math.round(splitTx * 1e6)));
    muteFreqUntil = Date.now() + 1200;
  } else {
    // Zwykle QSY zawsze wylacza split -- takze ten wlaczony recznie w radiu albo
    // "zapomniany" po odstrojeniu (patrz splitRx w readLoop)
    splitTx = null;
    if (driver.splitOff) cmds.push(...driver.splitOff());
  }
  await write(cmds);
  splitRx = splitTx ? Number(freqMHz) : null;
  emit({ splitTx, repeater });
  setTimeout(() => write(driver?.poll() || []), 250);      // szybkie potwierdzenie na wyswietlaczu
}

export async function rigSplitOff() {
  if (!driver || !port) return;
  await write([...(driver.splitOff ? driver.splitOff() : []), ...(state.repeater && driver.simplex ? driver.simplex() : [])]);
  splitRx = null;
  emit({ splitTx: null, repeater: false });
}

// ── Nadawanie: tylko po wlaczeniu zgody w panelu radia ────────────────────────
function requireTx() {
  if (!driver || !port) throw new Error(tx('Radio nie jest podłączone'));
  if (!state.allowTx) throw new Error(tx('Nadawanie z loggera jest wyłączone — włącz zgodę w panelu „Radio przez USB”'));
}
export async function rigPtt(on) {
  if (on) requireTx();
  if (!driver?.ptt || !port) return;
  clearTimeout(pttTimer); pttTimer = null;
  await write(driver.ptt(!!on));
  if (on) pttTimer = setTimeout(() => { rigPtt(false).catch(() => {}); }, PTT_MAX_MS);
  else { smeterSamples = []; lastSeen = Date.now(); }
  emit({ ptt: !!on, ...(on ? {} : { smeterPeak: null }) });
}
export async function rigSendCw(text) {
  requireTx();
  if (!driver.cw) throw new Error(tx('To radio nie przyjmuje tekstu CW przez CAT'));
  const cmds = driver.cw(text);
  if (!cmds.length) throw new Error(tx('Pusty tekst CW'));
  await write(cmds, 120);
}
export async function rigStopCw() {
  if (driver?.cwStop && port) await write(driver.cwStop());
}

// ── Wykrywanie radia: probujemy predkosci i protokolow, az radio odpowie ──────
const DETECT_BAUDS = [115200, 38400, 19200, 9600, 4800, 57600];
async function withPort(p, baud, stopBits, fn) {
  await p.open({ baudRate: baud, dataBits: 8, parity: 'none', flowControl: 'none', stopBits });
  try { await p.setSignals({ dataTerminalReady: false, requestToSend: false }); } catch { /* nie kazdy port */ }
  const ask = async (bytes, ms = 350) => {
    const w = p.writable.getWriter();
    try { await w.write(bytes); } finally { w.releaseLock(); }
    const r = p.readable.getReader();
    const got = [];
    const stopAt = Date.now() + ms;
    try {
      for (;;) {
        const left = stopAt - Date.now();
        if (left <= 0) break;
        const res = await Promise.race([r.read(), new Promise(ok => setTimeout(() => ok(null), left))]);
        if (!res || res.done) break;
        got.push(...res.value);
      }
    } finally {
      try { await r.cancel(); } catch { /* nic */ }
      try { r.releaseLock(); } catch { /* nic */ }
    }
    return got;
  };
  try { return await fn(ask); } finally { try { await p.close(); } catch { /* nic */ } }
}
// Rozpoznanie odpowiedzi -- czyste funkcje (testowane)
export function identifyAscii(text) {
  const m = /FA(\d{8,11});/.exec(text);
  if (!m) return null;
  return m[1].length === 11 ? 'kenwood' : 'yaesu';
}
export function identifyCiv(bytes) {
  for (let i = 0; i + 5 < bytes.length; i++) {
    if (bytes[i] === 0xFE && bytes[i + 1] === 0xFE && bytes[i + 3] !== CTRL && bytes[i + 3] !== 0x00 && bytes[i + 4] === 0x03) return bytes[i + 3];
  }
  return null;
}
export async function detectRig() {
  if (!isWebSerialSupported()) throw new Error('Web Serial nie jest dostepny w tej przegladarce');
  await disconnectRig(false);
  let p;
  try { p = await navigator.serial.requestPort(); } catch { return null; }
  let found = null;
  try {
    for (const baud of DETECT_BAUDS) {
      emit({ detecting: baud });
      found = await withPort(p, baud, 1, async (ask) => {
        const text = new TextDecoder().decode(new Uint8Array(await ask(enc('FA;'))));
        const kind = identifyAscii(text);
        if (kind === 'yaesu') return { presetId: 'ft991', baud };
        if (kind === 'kenwood') {
          const k = new TextDecoder().decode(new Uint8Array(await ask(enc('K2;'), 250)));
          return { presetId: /K2\d;/.test(k) ? 'elecraft' : 'kenwood', baud };
        }
        const civ = identifyCiv(await ask(new Uint8Array([0xFE, 0xFE, 0x00, CTRL, 0x03, 0xFD])));
        if (civ != null) {
          const preset = RIG_PRESETS.find(x => x.protocol === 'icom' && x.civ === civ && x.baud === baud)
            || RIG_PRESETS.find(x => x.protocol === 'icom' && x.civ === civ);
          return { presetId: preset ? preset.id : 'icom', baud, civ };
        }
        return null;
      }).catch(() => null);
      if (!found && [4800, 9600, 38400].includes(baud)) {
        found = await withPort(p, baud, 2, async (ask) => {
          const b = await ask(new Uint8Array([0, 0, 0, 0, 0x03]), 400);
          const ok = b.length === 5 && b.slice(0, 4).every(x => (x >> 4) <= 9 && (x & 0x0F) <= 9) && LEGACY_READ[b[4]] !== undefined;
          return ok ? { presetId: 'ft817', baud } : null;
        }).catch(() => null);
      }
      if (found) break;
    }
  } finally { emit({ detecting: null }); }
  if (!found) {
    emit({ error: tx('Nie wykryto radia — sprawdź kabel i czy port nie jest zajęty, albo wybierz model ręcznie') });
    return null;
  }
  await connectRig({ ...found, portObj: p });
  return found;
}

// Po odswiezeniu strony: jesli wczesniej polaczono i przegladarka pamieta zgode na port
export async function autoReconnectRig() {
  const c = savedRigConfig();
  if (!c?.auto || !isWebSerialSupported() || port) return;
  try { await connectRig({ ...c, pick: false }); } catch { /* cicho -- uzytkownik polaczy recznie */ }
}

if (isWebSerialSupported()) {
  navigator.serial.addEventListener?.('disconnect', (e) => {
    if (port && e.target === port) disconnectRig(false);
  });
  // Zamkniecie karty w trakcie nadawania -- pusc PTT
  window.addEventListener?.('pagehide', () => { if (state.ptt && driver?.ptt) write(driver.ptt(false)); });
}

// Stan radia USB w formacie /api/cat/status (albo null, gdy nie jest podlaczone)
export function rigAsCatStatus(rig) {
  if (rig.status !== 'connected' || rig.frequency == null) return null;
  return { connected: true, frequency: rig.frequency, mode: rig.mode, smeterPeak: rig.smeterPeak, power: rig.power,
    splitTx: rig.splitTx, ptt: rig.ptt, source: 'webserial' };
}

export const getRigState = () => state;

export function useWebSerialRig() {
  return useSyncExternalStore((cb) => { listeners.add(cb); return () => listeners.delete(cb); }, () => state);
}
